import { render, staticRenderFns } from "./AnswersWithSelect.vue?vue&type=template&id=645aea26&scoped=true&"
import script from "./AnswersWithSelect.vue?vue&type=script&lang=js&"
export * from "./AnswersWithSelect.vue?vue&type=script&lang=js&"
import style0 from "./AnswersWithSelect.vue?vue&type=style&index=0&id=645aea26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645aea26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
